import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
}

function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const [animate, setAnimate] = useState(false);
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (prevPath.current !== location.pathname) {
      setAnimate(false);
      // petite temporisation pour forcer le reflow et redéclencher l'animation
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setAnimate(true);
        });
      });
      prevPath.current = location.pathname;
    } else {
      setAnimate(true);
    }
  }, [location.pathname]);

  return (
    <div
      className={`transition-all duration-500 ease-[cubic-bezier(0.25,0.46,0.45,0.94)] ${
        animate
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-4'
      }`}
    >
      {children}
    </div>
  );
}

export default PageTransition;